import { render } from "./PostAdministatorMenuContext.vue?vue&type=template&id=071fee82&scoped=true"
import script from "./PostAdministatorMenuContext.vue?vue&type=script&lang=js"
export * from "./PostAdministatorMenuContext.vue?vue&type=script&lang=js"

import "./PostAdministatorMenuContext.vue?vue&type=style&index=0&id=071fee82&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071fee82"]])

export default __exports__